// frontend/src/components/Layout.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, NavLink } from 'react-router-dom';
import '../styles/Layout.css';


const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Función para manejar error de carga de imagen
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    const fallback = e.target.nextElementSibling;
    if (fallback) {
      fallback.style.display = 'block';
    }
  };

  // Definición de módulos
  const menuItems = [
    { 
      path: '/', 
      label: 'Inicio',
      description: 'Dashboard principal'
    },
    { 
      path: '/documentos', 
      label: 'Documentos',
      description: 'Gestiona tus archivos'
    },
    { 
      path: '/formatos', 
      label: 'Formatos',
      description: 'Descarga plantillas'
    },
    { 
      path: '/calendario', 
      label: 'Calendario',
      description: 'Eventos y fechas'
    },
    { 
      path: '/perfil', 
      label: 'Perfil',
      description: 'Tus datos'
    }
  ];

  // Módulos adicionales para administradores
  if (user?.role?.includes('admin') || user?.role === 'super_admin_jasp') {
    menuItems.push(
      { 
        path: '/admin/usuarios', 
        label: 'Usuarios',
        description: 'Gestiona usuarios'
      },
      { 
        path: '/admin/instituciones', 
        label: 'Instituciones',
        description: 'Gestiona instituciones'
      }
    );
  }

  return (
    <div className="jasp-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        {/* Logo */}
        <div className="sidebar-logo">
          <img 
            src="/logo-jasp.png" 
            alt="JASP Logo" 
            className="logo-image"
            onError={handleImageError}
          />
          <div className="logo-fallback" style={{ display: 'none' }}>
            <h1>JASP</h1>
            <p>Sistema de Gestión</p>
          </div>
        </div>

        {/* Menú de navegación */}
        <nav className="sidebar-nav">
          {menuItems.map((item, index) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `nav-item-moderno ${isActive ? 'active' : ''}`
              }
              style={{ '--item-index': index }}
            >
              <div className="nav-text">
                <span className="nav-label">{item.label}</span>
                <span className="nav-description">{item.description}</span>
              </div>
            </NavLink>
          ))}
        </nav>

        {/* Footer con información del usuario */}
        <div className="sidebar-footer-moderno">
          <div className="user-info-moderno">
            <div className="user-avatar">
              {user?.nombre?.charAt(0) || 'U'}
            </div>
            <div className="user-details">
              <p className="user-name-moderno">{user?.nombre || 'Usuario'}</p>
              <p className="user-role-moderno">
                {user?.role?.replace(/_/g, ' ') || 'Sin rol'}
              </p>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn-moderno">
            Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;